/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import Button, { Props as ButtonProps } from "components/Button";

import styles from "./SettingsSubscriptionButton.module.scss";

export const SettingsSubscriptionButton: React.FC<ButtonProps> = ({
  children,
  ...restProps
}) => {
  return (
    <Button size="medium" className={styles.button} {...restProps}>
      {children}
    </Button>
  );
};

export default SettingsSubscriptionButton;
